import styled from "styled-components";

export const GridLayoutCountStyled = styled.div`
    input {
        border: 1px solid #d5d5d5;
        padding: 4px;
        box-sizing: border-box;
        text-align: center;
    }
`;